import React from 'react';
import { useTranslation } from 'react-i18next';
import { InputSelect } from '../../../../../../components/input/select';
import { TriggerMethodType } from '../../../../../../types/actions';
import { useActionParameterOptions } from '../../utils/use-action-parameter-options';

type TriggerMethodSelectProps = {
  triggerMethod: string;
  updateTriggerMethod: (triggerMethod: TriggerMethodType) => void;
};

export const TriggerMethodSelect: React.FC<TriggerMethodSelectProps> = ({ triggerMethod, updateTriggerMethod }) => {
  const { t } = useTranslation('action');
  const { triggerMethodsOptions } = useActionParameterOptions();

  const onChangeTriggerMethod = (method: string) => {
    updateTriggerMethod(method as TriggerMethodType);
  };

  return (
    <InputSelect
      options={triggerMethodsOptions}
      value={triggerMethod}
      onChange={onChangeTriggerMethod}
      label={t('action.create.conditions.sources.schedule.triggerMethod')}
    />
  );
};
